import React, { useEffect } from 'react';
import { useAppDispatch } from '../../app/hooks';
import { Box } from '@mui/material';
import loginBackground from '../../assets/LoginBackground.png';
import './Login.css';
import CircularProgress from '@mui/material/CircularProgress';
import { callback } from '../../AppSlice';
import { useNavigate, useSearchParams } from 'react-router-dom';

function LoginRedirect() {
  const [searchParams] = useSearchParams();
  const auth_code = searchParams.get('code');

  const dispatch = useAppDispatch();
  let navigate = useNavigate();

  useEffect(() => {
    dispatch(callback(auth_code || '')).then(() => navigate('/services'));
  }, []);

  return (
    <Box
      sx={{
        backgroundImage: `url(${loginBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: '100% 100%',
        backgroundColor: 'black',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <CircularProgress size={100} thickness={4} sx={{ color: 'var(--color-rio-red)' }} />
    </Box>
  );
}

export default LoginRedirect;
